import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";



import { Label, Input, FormFeedback } from 'reactstrap';


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileurl: ""
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    SetData(data) {
        this.setState({
            fileurl: data.url
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.firmas.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Firma"}
                buttonIcon={"fa fa-search fa-lg"}
                
                saveButton={false}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-md"}
                onGotData={(data) => this.SetData(data)}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos de la firma</p>
                        <div className="ui-row-2">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input type="text" name="nombre" disabled={true}></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                            <div className="ui-field">
                                <Label>Cargo</Label>
                                <Input type="text" name="cargo" disabled={true}></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>

                    {this.state.fileurl &&
                        <section className="ui-section-block mt-3">
                            <p className="ui-section-label">Imagen</p>
                            <img className="ui-image-preview" src={api.BASE_URL + this.state.fileurl} alt=""></img>
                        </section>
                    }
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Firmas/Detail.js